import * as React from 'react'
import {
  Easy,
  Freedom,
  Hours,
  Money,
  Speed,
  Transparency,
} from '../../atoms/images/value-props'
import { ValueProp } from './types'

import * as t from './strings'

export const ValuePropsList: ValueProp[] = [
  {
    title: t.props.money.title(),
    description: t.props.money.description(),
    image: <Money width={60} height={49} />,
  },
  {
    title: t.props.hours.title(),
    description: t.props.hours.description(),
    image: <Hours width={60} height={49} />,
  },
  {
    title: t.props.freedom.title(),
    description: t.props.freedom.description(),
    image: <Freedom width={60} height={49} />,
  },
  {
    title: t.props.easy.title(),
    description: t.props.easy.description(),
    image: <Easy width={60} height={49} />,
  },
  {
    title: t.props.speed.title(),
    description: t.props.speed.description(),
    image: <Speed width={60} height={49} />,
  },
  {
    title: t.props.transparency.title(),
    description: t.props.transparency.description(),
    image: <Transparency width={60} height={49} />,
  },
]
